import React from 'react'
import PropTypes from 'prop-types'
import { useCrmWriteLock } from '../../hooks/useCrmWriteLock'

/**
 * Hides children when the org is CRM read-only (same signal as `CrmWriteGate`).
 * Use for inline tooltip divs and other decorative DOM that should not show when the parent is gated.
 */
export function HideWhenCrmWriteLocked ({ children, className }) {
  const { locked } = useCrmWriteLock()

  if (!locked) {
    return <>{children}</>
  }

  return (
    <span className={className} style={{ display: 'none' }} aria-hidden='true'>
      {children}
    </span>
  )
}

HideWhenCrmWriteLocked.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string
}
